import { LOCAL_SEMANTIC_MODEL } from "../model/known-models.js";
import { getSemanticModelMainEntity, isMainSemanticModelEntity } from "./concepts/index.js";
/**
 * Provides entities as semantic model.
 *
 * It translates generic entities and interprets them as semantic entities.
 *
 * The deprecated view exposes vocabulary entities only. Model metadata stays
 * in the underlying entity record for label access and serialization.
 *
 * @deprecated Use model store instead to manage the model state.
 */
export class SemanticModelAdapter {
    entityModel;
    constructor(entityModel) {
        this.entityModel = entityModel;
    }
    getId() {
        return this.entityModel.getId();
    }
    getAlias() {
        const label = getSemanticModelMainEntity(this.entityModel.getEntities())?.label;
        return label ? (label["en"] ?? Object.values(label)[0]) ?? null : null;
    }
    setAlias(alias) {
        const entityModel = this.entityModel;
        if (!entityModel.change) {
            return;
        }
        const current = getSemanticModelMainEntity(entityModel.getEntities());
        const mainEntity = current ?? { id: this.getId(), type: [LOCAL_SEMANTIC_MODEL] };
        const nextEntity = Object.assign({}, mainEntity, {
            label: alias === null ? {} : { cs: alias },
        });
        entityModel.change({
            [mainEntity.id]: nextEntity,
        }, []);
    }
    getEntities() {
        return Object.fromEntries(Object.entries(this.entityModel.getEntities())
            .filter(([, entity]) => !isMainSemanticModelEntity(entity)));
    }
    subscribeToChanges(callback) {
        return this.entityModel.subscribeToChanges((updated, removed) => {
            const updatedEntities = Object.fromEntries(Object.entries(updated)
                .filter(([, entity]) => !isMainSemanticModelEntity(entity)));
            const removedEntities = removed.filter(id => id !== this.getId());
            if (Object.keys(updatedEntities).length > 0 || removedEntities.length > 0) {
                callback(updatedEntities, removedEntities);
            }
        });
    }
}
//# sourceMappingURL=semantic-model-adapter.js.map